import React, { useCallback, useContext, useEffect, useState } from "react";
import { ChevronBottom, Person1, Power } from "@zkt/icons";
import { useUser, I18nContext, logout } from "@zkt/eb-utility";
import { Button, Popover, Avatar } from "@zkt/components";
import "./user-info.scss";
import { iframeClick$ } from "@/observables/iframe-message";
import { I18nTextType } from "./i18n";

export default function UserPopover(): JSX.Element {
  const { user } = useUser();
  const showSwitchOldVersion = !user?.channelCode;
  const [visible, setVisible] = useState(false);
  // const accountInfoUrl = `/#${formatUrl("/index.php?p=myaccount")}`;
  const accountInfoUrl = `/basic/user-settings`;
  const i18n = useContext<I18nTextType>(I18nContext);
  const modifyAccountInfo = useCallback(() => {
    // router.push(accountInfoUrl);
    setVisible(false);
    window.location.href = accountInfoUrl;
  }, [accountInfoUrl]);
  useEffect(() => {
    const subscription = iframeClick$.subscribe(() => setVisible(false));
    return () => subscription.unsubscribe();
  }, []);
  const handleLogout = useCallback(() => {
    logout({ callback: window.location.origin });
  }, []);
  const content = (
    <>
      {showSwitchOldVersion ? (
        <Button type="link" onClick={modifyAccountInfo}>
          <Person1 />
          {i18n.modifyAccountInfo}
        </Button>
      ) : null}
      <Button type="link" onClick={handleLogout}>
        <Power />
        {i18n.signout}
      </Button>
    </>
  );
  return (
    <Popover
      className="main-index-user-info"
      visible={visible}
      onVisibleChange={setVisible}
      overlayClassName="main-index-user-content"
      content={content}
      trigger="click"
    >
      <Avatar size={32} />
      <span className="user-name">{user?.realname}</span>
      <ChevronBottom />
    </Popover>
  );
}
